import { render } from "./NodeContext.vue?vue&type=template&id=2fc5c59f&ts=true"
import script from "./NodeContext.vue?vue&type=script&lang=ts"
export * from "./NodeContext.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__